import addressFormatter from "@fragaria/address-formatter";

const propertyIsNull = (obj) => Object.getOwnPropertyNames(obj).length === 0;

const removeUnusedProperties = (obj) =>
  Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== "" && v));

const createErrorMessages = (obj) => {
  const messages = [];
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      messages.push(obj[key]);
    }
  }
  return messages;
};

const formatAddress = (obj) => {
  return addressFormatter.format(obj, {
    output: "array",
  });
};

export {
  propertyIsNull,
  removeUnusedProperties,
  createErrorMessages,
  formatAddress,
};
